import React, { useRef, useState } from "react";
import ErrorLabelWithValue from "../ErrorLabelWithValue/ErrorLabelWithValue";
import HintLabel from "../HintLabel/HintLabel";
import Label from "../Label/Label";
import InfoIcon from "../InfoIcon/InfoIcon";
import InputDescription from "../InputDescription/InputDescription";
import PendingFieldConfirmButton from "../PendingFieldConfirmButton/PendingFieldConfirmButton";
import "./checkbox.scss";
import { isFocused } from "../../utilities";

const Checkbox = (props) => {
  const {
    id,
    label,
    value,
    isRequired,
    description,
    disabled,
    hintText,
    validations,
    error,
    pending,
    onChange,
  } = props;
  const [show, setShow] = useState(false);
  const checkboxRef = useRef(null);
  const handleToggle = () => setShow(!show);

  return (
    <div className="input-field checkbox-field">
      <strong className="dcr-label"></strong>
      <div>
        <div
          className={`input-field__inner-wrapper ${
            pending ? "pending-label" : ""
          }`}
        >
          <div className="input-field__confirm-wrapper">
            <div className="checkbox-field__wrapper">
              <input
                ref={checkboxRef}
                type="checkbox"
                name={id}
                checked={value || false}
                title={hintText}
                disabled={disabled}
                onChange={onChange}
              />
              <Label>{label}</Label>
            </div>
            {pending && value && !isFocused(checkboxRef.current) && (
              <PendingFieldConfirmButton onClick={() => onChange(`${value}`)} />
            )}
          </div>
          {description && <InfoIcon onClick={handleToggle} active={show} />}
        </div>
        <ErrorLabelWithValue
          isRequired={isRequired}
          error={error}
          validations={validations}
        />
        {hintText && <HintLabel>{hintText}</HintLabel>}{" "}
        {description && show && <InputDescription>{description}</InputDescription>}
      </div>
    </div>
  );
};

export default Checkbox;
